export const QUILL_FONT_PICKER = [
  'Montserrat',
  'Roboto',
  'Raleway',
  'Roboto Condensed',
  'Times New Roman',
  'Calibri',
  'Calibri Light',
  'Cambria',
  'Georgia',
  'Verdana',
  'Sans-Serif',
];

const IMPORTED_ONLY_FONTS = [
  'Arial',
  'Helvetica',
  'Tahoma',
  'Trebuchet MS',
  'Comic Sans MS',
  'Courier New',
  'Impact',
  'Lucida Console',
  'Palatino Linotype',
  'Book Antiqua',
  'Garamond',
  'Century Gothic',
  'Franklin Gothic Medium',
  'Open Sans',
  'Lato',
  'Source Sans Pro',
  'Oswald',
  'Nunito',
  'Poppins',
];

export const QUILL_FONT_WHITELIST = [
  ...QUILL_FONT_PICKER,
  ...IMPORTED_ONLY_FONTS,
];

export const registerQuillFontWhitelist = (Quill) => {
  const fonts = Quill.import('attributors/style/font');
  fonts.whitelist = QUILL_FONT_WHITELIST;
  Quill.register(fonts, true);
  return fonts;
};
